import React from 'react'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { Header } from './Header'
import { ItemsGrid } from 'LiveBoard/components/mobile/Items/ItemsGrid'
import { Loader } from 'shared/UI/Loader'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const SearchResults = (props) => {
  const {
    category, query, themeColorHex, onClose, items, itemIds,
    mostViewedItemId, isLoading, hasMorePages,
    onNextPage, onItemClick, shouldFetchNextPage,
    gatingEnabled, showViews, showLikes, showItemDescription,
    getTranslation
  } = props

  return (
    <div className="search-results-container">
      { (isEmpty(items) && isLoading) ? <Loader /> : (
          <div className="search-results-content">
            <Header
              itemsCount={category.itemsCount}
              query={query}
              onClose={onClose} />
            { isEmpty(items) ? (
                <div className="empty-search-results">{getTranslation(TRANSLATION_VALUE_KEYS.noSearchResults)}</div>
              ) : (
                <ItemsGrid
                  items={items}
                  itemIds={itemIds}
                  mostViewedItemId={mostViewedItemId}
                  themeColorHex={themeColorHex}
                  isLoading={isLoading}
                  onNextPage={onNextPage}
                  hasMorePages={hasMorePages}
                  onItemClick={onItemClick}
                  shouldFetchNextPage={shouldFetchNextPage}
                  gatingEnabled={gatingEnabled}
                  showViews={showViews}
                  showLikes={showLikes}
                  showItemDescription={showItemDescription} />
              )
            }
          </div>
        )
      }
    </div>
  )
}

SearchResults.propTypes = {
  category: PropTypes.object,
  query: PropTypes.string,
  themeColorHex: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
  items: PropTypes.object,
  itemIds: PropTypes.array,
  mostViewedItemId: PropTypes.number,
  isLoading: PropTypes.bool,
  hasMorePages: PropTypes.bool,
  shouldFetchNextPage: PropTypes.bool
}

export default withTranslation(TRANSLATION_KEYS.searchResults)(SearchResults)